import Vue from "vue";
import Vuex from "vuex";

//引入
import menuState from "./modules/menu";
import appState from "./modules/app";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    //模块化
    menuState,
    appState,
  },
});
